import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Profits } from './profit.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }


  getAllByDate(fromDate: any, toDate: any, name: string) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbydate?" + "fromDate=" + fromDate +
      "&toDate=" + toDate + "&name=" + name);
  }

  getByOrderId(orderId: number) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyorderid?orderId=" + orderId);
  }

  getAllDirectCharged(fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbydirectCharged?" + "fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getByUser(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyuser?userId=" + userId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllByCategory(categoryId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbycategoryanddate?categoryId=" + categoryId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllBySubCategory(subCategoryId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbysubcategoryanddate?subCategoryId=" + subCategoryId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllByProduct(productId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/getbyproductanddate?productId=" + productId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getMandoobStatment(id: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/mandoobstatment/" + id + "?fromDate=" + fromDate + "&toDate=" + toDate);
  }

  getAllCustomers(userId: string) {
    return this.http.get<[]>(this.global.APIURL + "users/customerlist/" + userId);
  }

  getUserTrans(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "usertransbydate/" + userId + "?fromDate=" + fromDate
      + "&toDate=" + toDate);
  }

  getUserTransDeposits(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURLV2 + "usertrans/usertransdeposits/" + userId + "?fromDate=" + fromDate
      + "&toDate=" + toDate);
  }

  getProfits(productId: number, fromDate: any, toDate: any, basicPrice: number) {
    return this.http.get<Profits>(this.global.APIURL + "reports/getprofits?productId="
      + productId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&basicPrice=" +
      basicPrice);
  }

  getProductCards(productId: number, status: number, fromDate: any, toDate: any,
    orderFromDate: any, orderToDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/productcards?productId=" + productId
      + "&status=" + status + "&fromDate=" + fromDate + "&toDate=" + toDate
      + "&orderFromDate=" + orderFromDate + "&orderToDate=" + orderToDate);
  }

  userTransAll(userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/usertransallreport?userId=" + userId + "&fromDate=" +
      fromDate + "&toDate=" + toDate);
  }

  getPyticOrdersId(orderId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURL + "reports/pyticorderscards?orderId=" + orderId +
      "&fromDate=" + fromDate + "&toDate=" + toDate + "&name=" + name);
  }

  userTransForMandoob(mandoobId: number, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURLV2 + "usertrans/getformandoob?mandoobId=" + mandoobId
      + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  userTransForUserByMandoob(mandoobId: number, mandoobAspId: string, userId: string, fromDate: any, toDate: any) {
    return this.http.get<[]>(this.global.APIURLV2 + "usertrans/getforuserbymandoob?mandoobId="
      + mandoobId + "&mandoobAspId=" + mandoobAspId + "&userId=" + userId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }


}
